// extracted by css-extract-rspack-plugin
var _1 = "filter-tdgG8Y";
var _2 = "query-pJiQdp";
var _3 = "table-zJbGV2";
export { _1 as "filter", _2 as "query", _3 as "table" }
